export default __webpack_public_path__ + "img/124594e69c4e05e53d84199add0e54fd.png";